import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { owner } from "../data/content";
import AuthButton from "./AuthButton";

const links = [
  { to: "/", label: "About", testid: "nav-link-about", end: true },
  { to: "/books", label: "Books", testid: "nav-link-books" },
  { to: "/trek-and-travel", label: "Trek & Travel", testid: "nav-link-trek" },
  { to: "/music", label: "Music Corner", testid: "nav-link-music" },
  { to: "/ai-media", label: "AI Media", testid: "nav-link-ai-media" },
  { to: "/blogs", label: "Blogs", testid: "nav-link-blogs" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 border-b border-[#D8D3CC]"
      style={{
        backgroundColor: "var(--surface-glass)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
      }}
      data-testid="site-navbar"
    >
      <nav className="container-narrow flex items-center justify-between py-5">
        <Link
          to="/"
          className="flex items-baseline gap-3 group"
          data-testid="nav-brand-link"
          onClick={() => setOpen(false)}
        >
          <span className="font-serif text-2xl sm:text-3xl text-[#2C2A28] leading-none">
            {owner.name.split(" ")[0]}
            <span className="italic text-[#4A6B53]">.</span>
          </span>
          <span className="hidden sm:inline text-xs tracking-[0.22em] uppercase text-[#5C5852]">
            personal journal
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                end={l.end}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `nav-underline text-[14px] tracking-wide transition-colors ${
                    isActive
                      ? "text-[#4A6B53]"
                      : "text-[#2C2A28] hover:text-[#4A6B53]"
                  }`
                }
              >
                {({ isActive }) => (
                  <span data-active={isActive ? "true" : "false"}>
                    {l.label}
                  </span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center">
          <AuthButton />
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 -mr-2 text-[#2C2A28]"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          className="lg:hidden border-t border-[#D8D3CC]"
          style={{ backgroundColor: "var(--bg)" }}
          data-testid="nav-mobile-menu"
        >
          <ul className="container-narrow py-4 flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.end}
                  onClick={() => setOpen(false)}
                  data-testid={`${l.testid}-mobile`}
                  className={({ isActive }) =>
                    `block py-3 px-2 text-base ${
                      isActive
                        ? "text-[#4A6B53]"
                        : "text-[#2C2A28]"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li className="pt-3 pb-2 px-2 border-t border-[#D8D3CC] mt-2">
              <AuthButton compact />
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
